<template>
    <div class="card mt-2 mb-2 ms-5 me-5">
        <div class="card-body">
            <h4>
                <strong>Datos de cotización </strong>
            </h4>
            <div class="table-responsive">
                <table class="mx-auto">
                    <tbody>
                        <tr>
                            <td></td>
                            <td></td>
                            <td class="lblform"><strong>Cantidad de piezas:</strong></td>
                            <td class="inputForm">
                                <input id="amount" type="number" min="1" placeholder="1" class="form-control avilable-input"
                                    v-model="quantity" @change="changeQuantity" />
                            </td>
                        </tr>
                        <tr>
                            <td class="lblform"><strong> Peso del material por unidad:
                                    <br> <i>(Kilogramos)</i> </strong></td>
                            <td class="inputForm">
                                <input id="unitWeight" type="number" readonly class="form-control" v-model="weightByUnit" />
                            </td>
                            <td class="lblform">
                                <strong>Peso total del material:
                                    <br> <i>(Kilogramos)</i>
                                </strong>
                            </td>
                            <td class="inputForm">
                                <input type="number" id="totalWweight" readonly class="form-control"
                                    v-model="totalWeight" />
                            </td>
                        </tr>
                        <tr>
                            <td class="lblform"><strong>Precio por unidad: </strong></td>
                            <td class="inputForm">
                                <input type="text" id="unitPrice" readonly class="form-control" v-model="unitPrice" />
                            </td>
                            <td class="lblform">
                                <strong><i>Precio Final: </i></strong>
                            </td>
                            <td class="inputForm">
                                <input type="text" id="totalPrice" readonly class="form-control" v-model="finalPrice" />
                            </td>
                            <td class="lblform">
                                <strong><i>Precio con descuento: </i></strong>
                            </td>
                            <td class="inputForm">
                                <input type="text" id="descountPrice" readonly class="form-control"
                                    v-model="discountPrice" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <button class="btn btn-danger" @click.prevent="goBack()"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                    height="16" fill="currentColor" class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                        d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                </svg> Materias P. no procesadas</button>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        getKiloPrice: Number,
        getWeightMeter: Number,
        getLengthValue: Number,
    },
    watch: {
        getKiloPrice(newVal) {
            if (newVal !== null) {
                this.calculateRawMaterialPrice();
            }
        },
        getWeightMeter(newVal) {
            if (newVal !== null) {
                // console.log("Peso por metro profilePriceCom:" + this.getWeightMeter);
                this.calculateWeight();
            }
        },
        getLengthValue(newVal) {
            if (newVal !== null) {
                // console.log("Desde el hijo length", this.getLengthValue);
                //this.finalPrice=this.unitPrice;
                this.calculateRawMaterialPrice();
                this.calculateWeight();
            }
        },
    },
    data() {
        return {
            weightByUnit: 0,
            totalWeight: 0,
            quantity: 1,
            //Valor de materia prima (Con IVA e utilidad)
            unitPrice: 0,
            //Valor final del producto incluido los servicios
            finalPrice: 0,
            //Valor final del producto con descuento
            discountPrice: 0,
            //Constantes
            constants: [],
            // Variable goblal para el precio en bruto
            grossRawMatPrice: 0,
            //Variable adiconal para almacenar el precio unitario con descuento.
            discountByUnit: 0,
        };
    },
    methods: {
        changeQuantity() {
            //console.log(this.weightByUnit);
            //console.log(this.quantity);
            //console.log(this.discountByUnit);
            this.totalWeight = this.quantity * this.weightByUnit;
            this.finalPrice = this.roundAndFormatPrice(this.quantity * parseFloat(this.unitPrice.replace(/\./g, '').replace(',', '.')));
            this.discountPrice = this.roundAndFormatPrice(this.quantity * parseFloat(this.discountByUnit.replace(/\./g, '').replace(',', '.')));
        },
        calculateRawMaterialPrice() {
            let constIva = this.constants[0].value / 100;
            //console.log(constIva);
            //let constUtility = (100 - this.constants[1].value) / 100;
            let constUtility = 0.9;
            //console.log(constUtility);
            let constDiscount = (100 - this.constants[2].value) / 100;
            //console.log(constDiscount);

            // --- Calculo del precio bruto de la materia prima
            // --- Area
            let rawMatArea = (this.getLengthValue / 100);
            //console.log(rawMatArea);

            this.grossRawMatPrice = rawMatArea * this.getWeightMeter * this.getKiloPrice;
            // console.log(this.grossRawMatPrice);


            // --- Se añade impuestos e utilidad
            let netRawMaterialPrice = (this.grossRawMatPrice + (this.grossRawMatPrice * constIva)) / constUtility;
            // console.log(this.grossRawMatPrice * constIva);
            // console.log(netRawMaterialPrice);

            // //Calculo de precio unitario con descuento
            let discountRawMaterialPrice = netRawMaterialPrice * constDiscount;

            // //--- Aplicar formato y redondear el precio final y el precio con descuento
            let rawMatPriceFormattedAndRound = this.roundAndFormatPrice(netRawMaterialPrice);
            let rawMatDiscountPriceFormattedAndRound = this.roundAndFormatPrice(discountRawMaterialPrice);

            // //console.log(rawMatPriceFormattedAndRound);

            // //Asignar valores a los campos precioUnitario, precioFinal y precioDescuento
            this.unitPrice = rawMatPriceFormattedAndRound;
            this.finalPrice = this.unitPrice;
            this.discountPrice = rawMatDiscountPriceFormattedAndRound;
            this.discountByUnit = this.discountPrice;
        },
        roundAndFormatPrice(num) {
            const roundedNum = Math.ceil(num / 1000) * 1000;
            const formattedNum = roundedNum.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return formattedNum;
        },
        recalculateValues() {
            this.quantity = 1;
            this.totalWeight = this.getWeightMeter;
            this.calculateRawMaterialPrice();
        },
        async getConstants() {
            try {
                let res = await axios.get(RUTA_SERVIDOR + "api/variable/list", {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                });
                // console.log(res.data);
                if (!res.data) {
                    console.log("There has been a different error with the data.");
                } else {
                    // console.log(res.data);
                    this.constants = res.data;
                    // console.log(this.constants);
                }
            } catch (err) {
                console.log(`There has been an error ${err}`);
            }
        },
        goBack() {
            this.$router.push("/Families");
        },
        roundWeight(numero) {
            return Math.round(numero * 10) / 10;
        },
        calculateWeight() {
            this.weightByUnit = this.roundWeight(this.getWeightMeter * (this.getLengthValue / 100));
            this.totalWeight = this.roundWeight(this.weightByUnit * this.quantity);
        }
    },
    mounted() {
        this.getConstants();
    }
}
</script>
<style scoped>
.card {
    border: solid 2px #a6323b;
}

.avilable-input {
    background-color: #FCE196;
}
</style>